import { render, staticRenderFns } from "./purchaseManage.vue?vue&type=template&id=de1b8bb8&scoped=true&"
import script from "./purchaseManage.vue?vue&type=script&lang=js&"
export * from "./purchaseManage.vue?vue&type=script&lang=js&"
import style0 from "./purchaseManage.vue?vue&type=style&index=0&id=de1b8bb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1b8bb8",
  null
  
)

export default component.exports